import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Icon } from "./icons";
import { HelpButton } from "./Help";

const NAV: [string, string, string][] = [
  ["", "Dashboard", "dashboard"], ["clients", "Clients", "clients"], ["rentals", "Rentals", "rentals"],
  ["payments", "Payments", "payments"], ["vehicles", "Fleet", "fleet"], ["maintenance", "Maintenance", "maintenance"],
  ["shop", "Shop", "shop"], ["settings", "Settings", "settings"],
];

export function AppShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onSignOut = () => { logout(); navigate("/app/login", { replace: true }); };
  const initials = (user?.email ?? "OA").slice(0, 2).toUpperCase();

  return (
    <div className="min-h-screen flex bg-paper">
      <aside className="w-[234px] shrink-0 bg-ink text-white flex flex-col p-3.5">
        <div className="flex items-center gap-2.5 px-2 py-1.5 pb-5">
          <span className="h-[30px] w-[30px] rounded-[9px] bg-white grid place-items-center">
            <span className="h-[11px] w-[11px] rounded-[3px] bg-accent" />
          </span>
          <span className="font-extrabold text-[18px] tracking-tight">FleetLease</span>
        </div>
        <nav className="flex-1 flex flex-col gap-[3px]">
          {NAV.map(([to, label, icon]) => (
            <NavLink key={to} to={`/app/${to}`} end={to === ""}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-accent text-white" : "text-white/55 hover:bg-white/[0.07] hover:text-white"
                }`}>
              <Icon name={icon} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto flex items-center gap-3 rounded-2xl bg-white/[0.06] p-2.5">
          <span className="h-[34px] w-[34px] rounded-[10px] bg-accent grid place-items-center text-[13px] font-bold text-white">{initials}</span>
          <div className="min-w-0">
            <div className="truncate text-[13px] font-semibold text-white">{user?.email ?? "Owner"}</div>
            <div className="text-xs text-white/45">{user?.role ?? "OWNER"}</div>
          </div>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 bg-paper-card border-b border-black/[0.06] flex items-center px-6 gap-4">
          <div className="relative flex-1 max-w-md">
            <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-ink-muted"><Icon name="search" size={17} width={2} /></span>
            <input aria-label="Search" placeholder="Search clients, vehicles, plate, VIN…"
              className="w-full rounded-xl bg-paper border border-transparent pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:border-accent focus:bg-paper-card" />
          </div>
          <div className="ml-auto flex items-center gap-4 text-sm">
            <span className="text-ink-muted hidden md:inline">{user?.email ?? "Owner"} · {user?.role ?? "OWNER"}</span>
            <HelpButton />
            <button onClick={onSignOut}
              className="rounded-xl border border-black/10 px-3.5 py-2 font-semibold hover:bg-black/[0.04]">Sign out</button>
          </div>
        </header>
        <main className="flex-1 p-7"><Outlet /></main>
      </div>
    </div>
  );
}
